import Flag from './components/Flag'

export default Flag


// WEBPACK FOOTER //
// ./src/index.js